import { useEffect } from 'react';
import { LoadGoogleAnalyticsScript } from '../../../core/utils/GoogleAnalyticTag';

const APGoogleHeaderScript = () => {
    const googleAnalyticsScript = LoadGoogleAnalyticsScript('header');

    useEffect(() => {
        if (!googleAnalyticsScript) return;

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.innerHTML = googleAnalyticsScript;
        document.head.appendChild(script);

        return () => {
            if (document.head.contains(script)) {
                document.head.removeChild(script);
            }
        };
    }, [googleAnalyticsScript]);

    return null;
};

export default APGoogleHeaderScript;
